
import { useTranslation } from "react-i18next";
import { FC, useMemo } from "react";
import {
    BottomBar,
    BottomBarContent,
    ProjectName,
    ButtonHolder,
    Button,
    ArrowRightIcon,
    LeftColumn
} from "./styles";
import { SelectedProjectDesc } from "shared/modals/sendProjects/styles";



interface PropsT {
    onPublish: () => void;
    onDeselect: () => void;
    selectedProjectName?: string;
    selectedCount?: number;
    maxProjects?: number;
    isEmptyRequest?: boolean;
    disabled?: boolean;
}

const CompetitionSelectPanel: FC<PropsT> = ({
    onPublish,
    onDeselect,
    selectedCount,
    selectedProjectName,
    maxProjects,
    isEmptyRequest,
    disabled,
}) => {
    const { t } = useTranslation();

    const titleText = useMemo(() => {
        if (maxProjects === 1 && selectedProjectName) {
            return t('competition.selected_project', { name: selectedProjectName });
        }
        return t('competition.selected_projects_panel', { count: selectedCount })
    }, [selectedCount, t, selectedProjectName, maxProjects]);

    if (!selectedCount && !isEmptyRequest) {
        return null;
    }

    return (
        <BottomBar>
            <BottomBarContent justify={isEmptyRequest ? 'flex-end' : 'space-between'}>
                {!isEmptyRequest && (
                    <LeftColumn>
                        <ProjectName>
                            {titleText}
                        </ProjectName>
                        {!!maxProjects && (
                            <SelectedProjectDesc>
                                {t('competition.max_projects', { count: maxProjects })}
                            </SelectedProjectDesc>
                        )}
                    </LeftColumn>
                )}
                <ButtonHolder>
                    {!isEmptyRequest && (
                        <Button variant='secondary' onClick={onDeselect}>
                            {t('competition.deselect')}
                        </Button>
                    )}
                    <Button variant='primary' onClick={onPublish} disabled={disabled}>
                        {t('competition.send')}
                        <ArrowRightIcon />
                    </Button>
                </ButtonHolder>
            </BottomBarContent>
        </BottomBar>
    )
}

export default CompetitionSelectPanel;
import { useTranslation } from "react-i18next";
import { FC, useMemo } from "react";
import {
    BottomBar,
    BottomBarContent,
    ProjectName,
    ButtonHolder,
    Button,
    ArrowRightIcon,
    LeftColumn
} from "./styles";
import { SelectedProjectDesc } from "shared/modals/sendProjects/styles";



interface PropsT {
    onPublish: () => void;
    onDeselect: () => void;
    selectedProjectName?: string;
    selectedCount?: number;
    maxProjects?: number;
    isEmptyRequest?: boolean;
    disabled?: boolean;
}

const CompetitionSelectPanel: FC<PropsT> = ({
    onPublish,
    onDeselect,
    selectedCount,
    selectedProjectName,
    maxProjects,
    isEmptyRequest,
    disabled,
}) => {
    const { t } = useTranslation();

    const titleText = useMemo(() => {
        if (maxProjects === 1 && selectedProjectName) {
            return t('competition.selected_project', { name: selectedProjectName });
        }
        return t('competition.selected_projects_panel', { count: selectedCount })
    }, [selectedCount, t, selectedProjectName, maxProjects]);

    if (!selectedCount && !isEmptyRequest) {
        return null;
    }

    return (
        <BottomBar>
            <BottomBarContent justify={isEmptyRequest ? 'flex-end' : 'space-between'}>
                {!isEmptyRequest && (
                    <LeftColumn>
                        <ProjectName>
                            {titleText}
                        </ProjectName>
                        {!!maxProjects && (
                            <SelectedProjectDesc>
                                {t('competition.max_projects', { count: maxProjects })}
                            </SelectedProjectDesc>
                        )}
                    </LeftColumn>
                )}
                <ButtonHolder>
                    {!isEmptyRequest && (
                        <Button variant='secondary' onClick={onDeselect}>
                            {t('competition.deselect')}
                        </Button>
                    )}
                    <Button variant='primary' onClick={onPublish} disabled={disabled}>
                        {t('competition.send')}
                        <ArrowRightIcon />
                    </Button>
                </ButtonHolder>
            </BottomBarContent>
        </BottomBar>
    )
}

export default CompetitionSelectPanel;